import React from 'react';
import { ALL_FIELD_TYPES } from '../../features/builder/fieldRegistry';
import * as Icons from 'react-icons/bi';

const QuestionTypePicker = ({ onSelect, onClose }) => (
  <div className="builder-type-picker" role="listbox" aria-label="Question types">
    {ALL_FIELD_TYPES.map((type) => {
      const Icon = Icons[type.icon] || Icons.BiText;
      return (
        <button
          key={type.key}
          type="button"
          className="builder-type-picker__item"
          role="option"
          onClick={() => { onSelect(type.key); onClose?.(); }}
        >
          <Icon aria-hidden="true" />
          <span>{type.name}</span>
        </button>
      );
    })}
  </div>
);

export default QuestionTypePicker;
